import { Box, Typography, Grid } from '@mui/material';

export default function SecaoFormulario({ titulo, icone, cor, children }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 1.5, pb: 0.8, borderBottom: `2px solid ${cor}` }}>
        {icone}
        <Typography sx={{ fontWeight: 700, fontSize: 12.5, textTransform: 'uppercase', letterSpacing: '0.05em', color: cor }}>
          {titulo}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {children}
      </Grid>
    </Box>
  );
}